import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { GetMedicationHistory } from "../../Apis/AuthApiServices";
import {
  loadingMedicationHistory,
  setMedicationHistory,
} from "../Slice/MedicationHistorySlice";

function* onLoadMedicationHistoryAsync({ payload }: any) {
  const params = new URLSearchParams();
  params.append("patientId", payload.patientId);
  params.append("drugStatus", payload.drugStatus);
  params.append("pageNumber", payload.pageNumber);
  try {
    const result: AxiosResponse = yield GetMedicationHistory(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setMedicationHistory({
          MedicationHistoryData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setMedicationHistory({
          MedicationHistoryData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error) {
    yield put(
      setMedicationHistory({
        MedicationHistoryData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some time!!",
      })
    );
  }
}

function* onLoadMedicationHistory() {
  yield takeLatest(loadingMedicationHistory.type, onLoadMedicationHistoryAsync);
}

const MedicationHistorySaga = [fork(onLoadMedicationHistory)];
export default MedicationHistorySaga;
